module.exports = __webpack_public_path__ + "2a7f130f34226f57b22a0291e5eb836e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center.html
// module id = 946
// module chunks = 0